

































































































































































































































import dayjs from "@/plugins/dayjs";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Util, getExcelJSONDataByList, getPageAPIs } from "@/common/util";
import { ShopDeclareInfoAPI } from "@/common/api/financeManage/shopDeclareMonthInfoList";

import { CommonApi } from "@/common/api/common";
import { excuteDownloadExport2Excel } from "@/common/xlsx";
import gallery from "@/components/gallery.vue";

// import MerchantApi from "@/common/api/merchant";
// import { util } from "vue/types/umd";
import { DeepLoop } from "@/common/deepLoop/deepLoop";
// import ZlSelect from "@/components/third-custom-components/select";

// import ZlOption from "@/components/third-custom-components/option";

import {
  shareConfirmOptions,
  getCommonList
} from "@/common/config";
export const pageApiList = getPageAPIs(ShopDeclareInfoAPI);

function getLast3MonthDate() {
  const lastEndDay = (dayjs() as any).format("YYYY-MM");

  const lastStartDay = (
    dayjs().subtract(2, "month").startOf("month") as any
  ).format("YYYY-MM");

  return [lastStartDay, lastEndDay];
}


const defaultForm = {
  shop_name: '',
  shop_id: '',
  is_status: 0, // 店铺状态  0全部 2上架  3下架
  time: [
    ...getLast3MonthDate()
  ],
}


// 商家端店铺类型 0未知 1台球商家端  2棋牌商家端


const defaultForms = {
  // media_type 媒体类型:0图片,1视频
  // media_list: [],

  shop_id: '',
  shop_name: '',
  unified_social_credit_code: '', // 统一社会信用代码
  address: '', // 地址 
  
  bank: '', // 开户银行

  account: '', // 银行账号

  name: '', // 法人姓名

  phone: '', // 法人联系电话

  license_register_time: '', //营业执照注册时间

  // singleMaxCountType: '0',
  // shop_id: "",
  // maxLimitCount: ''
};

// const defaultSearchVenuePageOption = {
//   page: 1,
//   limit: 10,
//   isRearchBottom: false,
// };

const shopDeclareDialogTitle2ch: any = {
  "new-shop-declare": "新增店铺申报",
  "edit-shop-declare": "编辑店铺申报",
};

function createPicItem(id: number, url: string) {
  const item = {
    id,
    url,
    href: url,
    type: "image/png",
    types: "1",
  };

  return item;
}

function createVideoItem(id: number, url: string) {
  const item = {
    id,
    url,
    href: url,
    type: "video/mp4",
    types: "2",
    poster: `${url}?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto`,
  };

  return item;
}

// 最大有效期
// const maxExpiredDays = 9999;

// 最大时长 单位分钟
// const maxTimeDuration = 24 * 60;

// const maxBenefitRate = 100

// 店铺状态 2上架  3下架
const shopStatus2Ch: string[] = ['', '', '上架', '下架']


@Component({
  filters: {
    showShopStatusName(status: number) {
      return shopStatus2Ch[status] || '未知'
    }
    // showPicOrThumbnail(row: any) {
    //   const { image_list, video_list } = row || {};

    //   if (Array.isArray(image_list) && image_list.length > 0) {
    //     return image_list[0].url || ""
    //   }

    //   if (Array.isArray(video_list) && video_list.length > 0) {
    //     return video_list[0] ? `${video_list[0].url}?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto` ||
    //             ""
    //         : "";
    //   }

    //   return ""
    // },




  },
  components: {
    gallery,
    // ZlSelect,
    // ZlOption,
  },
})
export default class ShopDeclareInfo extends Vue {
  private form: any = {
    // competitionPointId: "",
    // title: "", // 标题
    // shop_type: '', // 选择所属项目 
    // shop_id: '',
    // time: [],
    // startDate: "",
    // endDate: "",
  };
  private forms: any = {
    // maxType: "0",
    // ...defaultForms
  };

  private deepLoopUtil: any = {};

  private shopStatusList: any[] = [
    ...getCommonList(shopStatus2Ch, 2)
  ]

  // private merchantApi: any;

  private shopDeclareInfoApi = new ShopDeclareInfoAPI();


  private commonApi = new CommonApi();

  // private couponsManageAPI = new CouponsManageAPI();
  // private competitionPointTimeDurationAPI = new quickReplyManageTimeDurationManageAPI();
  constructor() {
    super();

    this.deepLoopUtil = new DeepLoop();

    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm, false)
    }

    this.forms = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };


   
  }

  private created(): void {
    this.getShopDeclareInfos();

    // this.refreshShopDeclareInfoTimeDurations();

    // this.refreshTableClass();
  }
  private restForm(): void {
    this.form = {
      ...this.deepLoopUtil.deepCopy(defaultForm, false)
    }

    this.getShopDeclareInfos();
  }
  //搜索
  private search(): void {
    this.tablePage.page = 1;
    this.tableData = [];
    this.tablePage.totalCount = 0;
    this.getShopDeclareInfos();
  }

  private tableData: any[] = [];

  // 上传视频
  // private userAvatarUploading: boolean = false;
  // private handleUploadUserVideo(file: any, fileList: any[]) {
  //   console.log(file, fileList, "file", "fileList");
  //   this.userAvatarUploading = true;
  //   this.commonApi.getOssvideo(
  //     file instanceof File ? file : file.raw,
  //     (res: any) => {
  //       console.log(res, "res 视频上传成功");

  //       const { data } = res;

  //       const { data: callbackData } = data;

  //       const { item: uploadImgObj } = callbackData || {};

  //       const { id, url } = uploadImgObj;

  //       // this.$set(this.forms, "video_id", id);
  //       // this.$set(this.forms, "video_url", url);

  //       this.forms.study_video = [createVideoItem(id, url)];

  //       this.userAvatarUploading = false;
  //     },
  //     ({ errMsg }: any) => {
  //       if (errMsg == "out of limit duration") {
  //         this.$message.error("视频时长不可超过1小时");
  //       } else {
  //         this.$message.error("视频上传失败");
  //       }

  //       this.userAvatarUploading = false;
  //     },
  //     {
  //       limit_duration: 60 * 60, // 单位 秒  1h
  //     },
  //     file.url
  //   );
  // }

  // private handleRemoveStudyVideo() {
  //   this.forms.study_video = [];
  // }

  // private uploadMediaOss(file: File): Promise<any> {
  //   return new Promise((resolve, reject) => {
  //     if (file.type && file.type.startsWith('image/')) {
  //       this.commonApi.getOss(
  //         file,
  //         (res: any) => {
  //          resolve({
  //           _media_type: 'image', 
  //           ...res
  //          })
  //         },
  //         (err: any) => {
  //           reject(err)
  //         }
  //       );
  //     } else if (file.type && file.type.startsWith('video/')) {
  //       this.commonApi.getOssvideo(
  //       file,
  //       (res: any) => {
  //         resolve({
  //           _media_type: 'video', 
  //           ...res
  //         })
  //       },
  //       (err: any) => {
  //         reject(err)
  //       }
  //     );
  //     }
  //   })
  // }

  // private async handleChangeUploadPic(file: any, fileList: any[]) {
  //   console.log(file, fileList, "file", "fileList");

  //   const {
  //     _media_type: mediaType,
  //     data: uploadOriginData = {}
  //   } = await this.uploadMediaOss(
  //     file instanceof File ? file : file.raw,
  //   ).catch(() => {
  //     this.$message.error('媒体文件上传失败')
  //   }) ;


  //   const { data: uploadImgObjWrap } = uploadOriginData;

  //   const { item: uploadImgObj } = uploadImgObjWrap;

  //   const { id, url } = uploadImgObj;

  //   switch (mediaType) {
  //     case 'image':
  //       this.forms.media_list.push(createPicItem(id, url));
  //       break;
  //     case 'video':
  //       this.forms.media_list.push(createVideoItem(id, url));
  //       break;
  //   }

    
  // }

  // private handleRemoveStudyPicture(file: any) {
  //   const forms = this.forms || {};
  //   const existIndex = forms.media_list.findIndex(
  //     (picFile: any) => picFile == file
  //   );

  //   if (existIndex > -1) {
  //     forms.media_list.splice(existIndex, 1);
  //   }
  // }

  // // 查看视频/图片
  // private handleBeforePreviewMedia(row: any) {
  //   const { image_list, video_list } = row || {};

  //   const previewItem: any = {};

  //   if (Array.isArray(image_list) && image_list.length > 0) {
  //     previewItem.image_count = image_list.length;

  //     previewItem.images = image_list.map((pic: any) => pic.url);
  //   }

  //   if (Array.isArray(video_list) && video_list.length > 0) {
  //     previewItem.video_count = video_list.length;

  //     previewItem.videos = video_list.map((pic: any) => pic.url);
  //   }
    
  //   this.handlePreviewMedia(previewItem);
  // }

  // private images: any = [];

  // private handleBeforePreviewPicture(row: any) {
  //   const forms = this.forms

  //   const {
  //     media_list
  //   } = forms || {}
    

  //   const urls: any[] = [];

  //   media_list.forEach((item: any) => {
  //     switch (item.types) {
  //       case "1":
  //         urls.push({
  //           title: "",
  //           type: "image/jpeg",
  //           href: item.url,
  //           thumbnail: item.url,
  //         })
  //         break;
  //       case "2":
  //         urls.push({
  //           title: "",
  //           type: "video/mp4",
  //           href: item.url,
  //           poster: `${item.url}?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto`,
  //         })
  //         break;
  //     }
  //   })

  //   this.images = urls;
  // }

  // private handlePreviewMedia(row: any) {
  //   const { image_count, images, video_count, videos } = row || {};

  //   const urls: any[] = [];

  //   if (image_count > 0) {
  //     urls.push(
  //       ...images.map((img: string) => {
  //         return {
  //           title: "",
  //           type: "image/jpeg",
  //           href: img,
  //           thumbnail: img,
  //         };
  //       })
  //     );
  //   }

  //   if (video_count > 0) {
  //     urls.push(
  //       ...videos.map((video: string) => {
  //         return {
  //           title: "",
  //           type: "video/mp4",
  //           href: video,
  //           poster: `${video}?x-oss-process=video/snapshot,t_0,f_jpg,w_0,h_0,m_fast,ar_auto`,
  //         };
  //       })
  //     );
  //   }

  //   console.log(urls, 'urls')

  //   this.images = urls;
  // }

  //dialog
  // private dialogFormVisible: boolean = false;
  private formLabelWidth: string = "120px";

  private tablePage: any = {
    count: 0,
    page: 1,
    prepage: 10,
    pageSizes: [10, 20, 50, 100, 200, 500],
    totalPage: 0,
  };
  // //翻页
  private handlePageChange(val: any) {
    this.tablePage.page = val.currentPage;
    this.tablePage.prepage = val.pageSize;
    this.getShopDeclareInfos();
  }

  // private addOrUpdateShopDeclareInfoTitle: string = "店铺申报信息";

  // private dialogFormVisible: boolean = false;


  // 拉起店铺申报信息弹框
  // private handleWakeShopDeclareInfoDialog(mode: string) {
  //   // if (mode == 'new-shop-declare') { // 新增店铺申报信息

  //   // }
  //   this.competitionPointDialogMode = mode;
  //   this.addOrUpdateShopDeclareInfoTitle =
  //     shopDeclareDialogTitle2ch[mode] || "店铺申报信息";

  //   this.initShopDeclareInfoForm(mode);

  //   this.dialogFormVisible = true;
  // }

  private currentShopDeclareInfoItem: any = null;

  private competitionPointDialogMode: string = "";

  private async initShopDeclareInfoForm(mode: string) {
    const forms: any = {
      ...this.deepLoopUtil.deepCopy(defaultForms, false),
    };

    if (mode == "edit-shop-declare") {
      const currentShopDeclareInfoItem = this.currentShopDeclareInfoItem;

      const {
        shop_id,
        shop_name,
        unified_social_credit_code = '',
        address = '',
        bank = '',
        account = '',
        name = '',
        phone = '',
        license_register_time = '',
        // image_list,
        // video_list
      } = currentShopDeclareInfoItem || {};

      Object.assign(forms, {
        shop_id,
        shop_name,
        unified_social_credit_code,
        address,
        bank,
        account,
        name,
        phone,
        license_register_time,
      });

      // if (Array.isArray(image_list) && image_list.length > 0) {
      //   forms.media_list.push(...image_list.map((item: any) => {
      //     const { url, id } = item || {};

      //     return createPicItem(id, url);
      //   }))
      // }

      // if (Array.isArray(video_list) && video_list.length > 0) {
      //   forms.media_list.push(...video_list.map((item: any) => {
      //     const { url, id } = item || {};

      //     return createVideoItem(id, url);
      //   }))
      // }


      // forms.id = id;
    }

    console.log(forms, "forms");

    this.forms = forms;
  }

  // private handleWakeEditShopDeclareInfoDialog(competitionPointItem: any) {
  //   this.currentShopDeclareInfoItem = competitionPointItem;

  //   this.handleWakeShopDeclareInfoDialog("edit-shop-declare");
  // }

  // private handleDelteShopDeclareInfoDialog(competitionPointItem: any) {
  //   this.$confirm("确定删除该店铺申报?", "", {
  //     ...shareConfirmOptions,
  //   }).then(() => {
  //     this.shopDeclareInfoApi.deleteShopDeclareInfo(
  //       {
  //         id: competitionPointItem.id,
  //       },
  //       () => {
  //         this.getShopDeclareInfos();
  //       },
  //       () => {}
  //     );
  //   });
  // }

  // 排序
  // private handleLimitUserSort(val: string) {
  //   Util.limitIntegetInput(
  //     val,
  //     (new_val: string) => {
  //       // const limit_val = Math.min(Number(new_val), maxBenefitRate).toString();
  //       this.$set(this.forms, "sort", new_val);
  //     },
  //     (new_val: string) => {
  //       this.$set(this.forms, "sort", new_val);
  //     }
  //   );
  // }

  private sumbitShopDeclareInfoLoading: boolean = false;

  // 提交店铺申报配置
  // private handleSumbitShopDeclareInfo() {
  //   const competitionPointDialogMode = this.competitionPointDialogMode;

  //   const params = this.getShopDeclareInfoFormsParams(
  //     competitionPointDialogMode
  //   );

  //   console.log(params, "params");
  //   if (params === false) return;

  //   this.sumbitShopDeclareInfoLoading = true;
  //   switch (competitionPointDialogMode) {
  //     case "new-shop-declare":
  //       // this.shopDeclareInfoApi.addShopDeclareInfo(
  //       //   params,
  //       //   () => {
  //       //     this.getShopDeclareInfos();
  //       //     this.dialogFormVisible = false;
  //       //     this.sumbitShopDeclareInfoLoading = false;
  //       //   },
  //       //   () => {
  //       //     this.sumbitShopDeclareInfoLoading = false;
  //       //   }
  //       // );
  //       break;
  //     case "edit-shop-declare":
  //       // this.shopDeclareInfoApi.updateShopDeclareInfo(
  //       //   params,
  //       //   () => {
  //       //     this.getShopDeclareInfos();
  //       //     this.dialogFormVisible = false;
  //       //     this.sumbitShopDeclareInfoLoading = false;
  //       //   },
  //       //   () => {
  //       //     this.sumbitShopDeclareInfoLoading = false;
  //       //   }
  //       // );
  //       break;
  //   }
  // }

  // private getShopDeclareInfoFormsParams(mode: string) {
  //   const params: any = {};

  //   const showErrorMessage = (msg: string) => {
  //     if (!!msg) {
  //       this.$message.error(msg);
  //     }
  //   };

  //   const forms = this.forms;

  //   const {
  //     shop_id,
  //     // name,
  //     // expired_days,
  //     // meituanId,
  //     // timeDuration
  //     // machine_number,
  //     // phone,
  //     // rank

  //     sort,
  //   } = forms || {};

  //   const keys = ["unified_social_credit_code", "address", "bank", "account", "name", "phone", "license_register_time"];

  //   const key2EndKey: any = {
  //     unified_social_credit_code: "unified_social_credit_code",
  //     address: "address",
  //     bank: "bank",
  //     account: "account",
  //     name: "name",
  //     phone: "phone",
  //     license_register_time: "license_register_time",
  //   };

  //   const key2ErrMsg: any = {
  //     unified_social_credit_code: "统一社会信用代码不能为空",
  //     address: "地址不能为空",
  //     bank: "开户银行不能为空",
  //     account: "银行账号不能为空",
  //     name: "法人姓名不能为空",
  //     phone: "法人联系电话不能为空",
  //     license_register_time: "unrequired"
  //   };

  //   for (let i = 0; i < keys.length; i++) {
  //     const key = keys[i];

  //     if (forms[key]) {
  //       const errMsg = key2ErrMsg[`${key}_${forms[key]}`];
  //       if (errMsg) {
  //         showErrorMessage(errMsg);

  //         return false;
  //       }
  //       params[key2EndKey[key] || key] = forms[key];
  //     } else {
  //       if (key2ErrMsg[key] !== 'unrequired') {
  //         showErrorMessage(key2ErrMsg[key]);

  //         return false;
  //       }
  //     }
  //   }

  //   Object.assign(params, {
  //     sort,
  //   });


  //   if (mode == "edit-shop-declare") {
  //     params.shop_id = shop_id;
  //   }

  //   return params;
  // }

  //获取店铺申报列表
  private getShopDeclareInfos(): void {
    this.shopDeclareInfoApi.getShopDeclareInfoList(
      { ...this.getShopDeclareInfoParams() },
      (res: any) => {
        // res.data.list
        this.tableData = res.data.list;
        this.tablePage.page = res.data.page;
        this.tablePage.prepage = res.data.prepage;
        // this.tablePage.totalPage = res.data.total;
        this.tablePage.count = res.data.count;
      },
      () => {}
    );
  }

  private getShopDeclareInfoParams(mode = "all"): any {
    const params: any = {};

    const form = this.form;

    const tablePage = this.tablePage;

    const { page, prepage } = tablePage;

    const { shop_id, shop_name, is_status, time } = form;

    Object.assign(params, {
      is_status
    })

    if (shop_name) {
      params.shop_name = shop_name;
    }

    if (shop_id) {
      params.shop_id = shop_id;
    }

    if (Array.isArray(time) && time.length === 2) {
      const [startDate, endDate] = time;

      // const startTime = Util.dateTimeUtilnohms(startDate);
      // const endTime = Util.dateTimeUtilnohms(endDate);

      params.start_date = startDate;

      params.end_date = endDate;
    }

    if (
      mode == "exportExcel" &&
      !(params.start_date && params.end_date)
    ) {
      this.$message.error("请选择日期导出数据");
      return null;
    }



    if (mode === "all") {
      if (page) {
        params.page = page;
      }

      if (prepage) {
        params.limit = prepage;
      }
      // outerParams.__isUnique = !firstLoading;
    }


   

    return params;
  }

  /** 导出excel */
  private downloadExcelLoading: boolean = false;

  // 字段名 文案对应关系
  private merchantExcelList2ch: any = {
    finance_date_str: "月份",
    shop_name: "店铺名称",
    
    shop_id: " 店铺ID",
    business_license_shop_name: "营业执照店铺名称",
    unified_social_credit_code: "统一社会信用代码",
    address: "地址",
    bank: "开户银行",
    account: "银行账号",
    name: "法人姓名",
    phone: "法人联系方式",
    license_register_time: "营业执照注册时间",
    total_income: "收入总额",
    refund_money: "退款金额",
    income_amount: "收入净额",
    platform_income: "平台技术服务费",
    order_business_num: "交易(订单)数量",
  };
  // 商户Excel 表头的先后顺序
  private merchantExcelSortList: string[] = [
    "finance_date_str",
    "shop_name",
    "shop_id",
    "business_license_shop_name",
    "unified_social_credit_code",
    "address",
    "bank",
    "account",
    "name",
    "phone",
    "license_register_time",
    "total_income",
    "refund_money",
    "income_amount",
    "platform_income",
    "order_business_num"
  ];

  // 点击导出excel 表格
  private handleExportExcelShopDeclareMonthInfoList() {
    const params = this.getShopDeclareInfoParams('exportExcel')

    if (params === null) {
      return false;
    }

    this.downloadExcelLoading = true;
    this.shopDeclareInfoApi.exportExcelShopDeclareInfoList(
      params,
      (res: any) => {
        const { start_date, end_date } = params || {};

        const filename = `店铺申报月度列表 ${start_date}到${end_date}.xlsx`;
        const { data } = res || {};

        const {
          list: originList
        } = data || {}

        const newList = Array.isArray(originList)
          ? originList.map((item) => {
              const {
                // status,
                // back_goods_detail
               } = item || {};
              const newItem = {
                ...(item || {}),
                // __status_text: withdrawAccountAudit2Text[status],
                // __back_good_details: back_goods_detail.map((goods: any, index: number) => `${ goods.name }x${ goods.num }  ¥${ goods.price }`).join('; \t')
              };

              for (let key in item) {
                if (typeof item[key] == 'number') {
                  newItem[key] = item[key].toString()
                }
              }

              return newItem;
            })
          : [];

        if (newList.length > 0) {
          const merchantExcelSortList = this.merchantExcelSortList;

          const merchantExcelList2ch = this.merchantExcelList2ch;

          const excelJSONData = getExcelJSONDataByList(
            newList,
            merchantExcelSortList,
            merchantExcelList2ch
          );

          excuteDownloadExport2Excel(excelJSONData, filename);
        } else {
          this.$message.info("选中时段没有可导出的信息");
        }

        this.downloadExcelLoading = false;
      },
      () => {
        this.downloadExcelLoading = false;
      }
    );
  }

  /** end 导出excel */

  private exportTable() {
    // new HealthWarning().exportTable(this.form);
  }

  private selectPage: any = {
    page: 1,
    prepage: 200,
    totalPage: 0,
    count: 0,
  };
}
